import type { GoodbyeLetterSettings } from './goodbye-letter-types.ts';

type WebsiteSettings = Pick<GoodbyeLetterSettings, 'onlinePaymentsEnabled' | 'onlinePaymentsUrl'>;

/** A saved URL is a manual override. With no override, follow the synced
 * payment-role contact on each generation; never save a copy as a fallback.
 * Callers validate the resolved URL before linking or generating a letter.
 */
export function resolveGoodbyePaymentWebsite(
  settings: WebsiteSettings | null | undefined,
  contactWebsite: string | null | undefined
): { source: 'disabled' | 'manual' | 'encompass'; url: string | null } {
  if (!settings?.onlinePaymentsEnabled) {
    return { source: 'disabled', url: null };
  }
  const override = settings.onlinePaymentsUrl?.trim();
  if (override) {
    return { source: 'manual', url: override };
  }
  return { source: 'encompass', url: contactWebsite?.trim() || null };
}
